import altoCustoGerenciamentoProcesso from './altoCustoGerenciamentoProcesso'
import dispensacao from './dispensacao'
import estornoDispensacao from './estornoDispensacao'
import filaAtendimento from './fila-atendimento'
import livroPsicotropico from './livroPsicotropico'
import livroTalidomida from './livroTalidomida'
import parametrizacao from './parametrizacao'
import relatorioAltoCustoDispensacao from './relatorioAltoCustoDispensacao'
import relatorioAltoCustoEstatisticoCid from './relatorioAltoCustoEstatisticoCid'
import relatorioAltoCustoProcesso from './relatorioAltoCustoProcesso'
import relatorioAltoCustoProcessoPaciente from './relatorioAltoCustoProcessoPaciente'
import relatorioAltoCustoRetiradaPendente from './relatorioAltoCustoRetiradaPendente'
import relatorioAtendimentoDiario from './relatorioAtendimentoDiario'
import relatorioDispensacao from './relatorioDispensacao'
import relatorioDispensacaoPaciente from './relatorioDispensacaoPaciente'
import relatorioDispensacaoRemedioCasa from './relatorioDispensacaoRemedioCasa'
import relatorioEstornoDispensacao from './relatorioEstornoDispensacao'
import relatorioMovimentacaoPsicotropico from './relatorioMovimentacaoPsicotropico'
import relatorioPacienteAtendido from './relatorioPacienteAtendido'
import relatorioQuantitativoDispensacao from './relatorioQuantitativoDispensacao'
import supervisor from './supervisor'
import relatorioMedicamentoNaoAtendido from './relatorioMedicamentoNaoAtendido'

export default [
    {
        path: 'farmacia',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...altoCustoGerenciamentoProcesso,
            ...dispensacao,
            ...estornoDispensacao,
            ...filaAtendimento,
            ...livroPsicotropico,
            ...livroTalidomida,
            ...parametrizacao,
            ...relatorioAltoCustoDispensacao,
            ...relatorioAltoCustoEstatisticoCid,
            ...relatorioAltoCustoProcesso,
            ...relatorioAltoCustoProcessoPaciente,
            ...relatorioAltoCustoRetiradaPendente,
            ...relatorioAtendimentoDiario,
            ...relatorioDispensacao,
            ...relatorioDispensacaoPaciente,
            ...relatorioDispensacaoRemedioCasa,
            ...relatorioEstornoDispensacao,
            ...relatorioMovimentacaoPsicotropico,
            ...relatorioPacienteAtendido,
            ...relatorioQuantitativoDispensacao,
            ...supervisor,
            ...relatorioMedicamentoNaoAtendido
        ]
    }
]